import PropTypes from "prop-types";
import React, { useState, useEffect, useRef } from "react";
import { Collapse } from "reactstrap";
import { Link, useLocation } from "react-router-dom";
import classname from "classnames";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { menuRoutes } from "../../enums/menuRoutes";

const Navbar = (props) => {
  const [admin, setAdmin] = useState(false);
  const [styles, setStyles] = useState(false);
  const location = useLocation();

  const adminRef = useRef(null);
  const stylesRef = useRef(null);

  const removeAllActive = (ul) => {
    const actives = ul.querySelectorAll(".active");
    actives.forEach(el => el.classList.remove("active"));
  };
  function activateParentDropdown(item) {
    item.classList.add("active");
    const parent = item.parentElement;
    if (parent) {
      parent.classList.add("active"); // li
      const parent2 = parent.parentElement;
      parent2.classList.add("active"); // li
      const parent3 = parent2.parentElement;
      if (parent3) {
        parent3.classList.add("active"); // li
        const parent4 = parent3.parentElement;
        if (parent4) {
          parent4.classList.add("active"); // li
          const parent5 = parent4.parentElement;
          if (parent5) {
            parent5.classList.add("active"); // li
            const parent6 = parent5.parentElement;
            if (parent6) {
              parent6.classList.add("active"); // li
            }
          }
        }
      }
    }
    return false;
  }

  useEffect(() => {
    const ul = document.getElementById("navigation");
    if (!ul) return;

    removeAllActive(ul);

    let matchingMenuItem = null;
    const path = location.pathname;
    
    for (const route of menuRoutes) {
      const isParent = path === route.parent;
      const isChild = path === route.children;

      if (isParent || isChild) {
        matchingMenuItem = ul.querySelector(
          `a[href="${route.parent}"]`
        );
        break;
      }
    }
    if (!matchingMenuItem) return;

    activateParentDropdown(matchingMenuItem);
  }, [location.pathname, props.userRoles, props.leftMenu]);
  useEffect(() => {
  const handleClickOutside = (event) => {
    if (adminRef.current && !adminRef.current.contains(event.target)) {
      setAdmin(false);
    }

    if (stylesRef.current && !stylesRef.current.contains(event.target)) {
      setStyles(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, []);

  return (
    <React.Fragment>
      <div className="topnav">
        <div className="container-fluid">
          <nav
            className="navbar navbar-light navbar-expand-lg topnav-menu"
          >
            <Collapse
              isOpen={props.leftMenu}
              className="navbar-collapse"
              id="topnav-menu-content"
            >
              <ul className="navbar-nav" id="navigation">
                {props.userRoles === null && <li className="nav-link"></li>}
                {props.userRoles !== null &&
                ["Admin"].some((role) => props.userRoles.includes(role)) ? (
                  <>
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setAdmin(!admin);
                          setStyles(false)
                        }}
                        className="nav-link dropdown-togglez arrow-none"
                        ref={adminRef}
                      >
                        <i className="fas fa-suitcase me-2"></i>
                        {props.t("Administrator")}{" "}
                        <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: admin })}
                      >
                        <Link
                          to="/users"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("User")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                        <Link
                          to="/regions"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("Region")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                        <Link
                          to="/businesses"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("Business")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </div>
                    </li>
                  </>
                ) : null}
                {props.userRoles !== null && ["BulkSubmitter", "BulkReviewer", "BulkPublisher", "BulkObsoleter"].some((role) => props.userRoles.includes(role)) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/bulk-actions">
                      <i className="fas fa-tasks me-2"></i>
                      <span>{props.t("Bulk Actions")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null && 
                ["Admin", "Author", "Reviewer", "Publisher"].some((role) => 
                  props.userRoles.includes(role)) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/documents">
                      <i className="fas fa-file-alt me-2"></i>
                      <span>{props.t("Documents")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null &&
                ["Admin", "Author", "Reviewer", "Publisher"].some((role) =>
                  props.userRoles.includes(role),
                ) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/sections">
                      <i className="fas fa-boxes me-2"></i>
                      <span>{props.t("Sections")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null &&
                ["Admin", "Author", "Reviewer", "Publisher"].some((role) =>
                  props.userRoles.includes(role),
                ) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/snippets">
                      <i className="fas fa-layer-group me-2"></i>
                      <span>{props.t("Snippets")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null &&
                ["Admin"].some((role) => props.userRoles.includes(role)) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/templates">
                      <i className="fas fa-paint-brush me-2"></i>
                      <span>{props.t("Templates")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null &&
                ["Admin"].some((role) => props.userRoles.includes(role)) ? (
                  <li className="nav-item">
                    <Link className="nav-link" to="/logos">
                      <i className="fas fa-image me-2"></i>
                      <span>{props.t("Logos")}</span>
                    </Link>
                  </li>
                ) : null}
                {props.userRoles !== null &&
                ["Admin"].some((role) => props.userRoles.includes(role)) ? (
                  <>
                    <li className="nav-item dropdown">
                      <Link
                        to="/#"
                        onClick={(e) => {
                          e.preventDefault();
                          setStyles(!styles);
                          setAdmin(false);

                        }}
                        className="nav-link dropdown-togglez arrow-none"
                        ref={stylesRef}
                      >
                        <i className="fas fa-code me-2"></i>
                        {props.t("Styles")} <div className="arrow-down"></div>
                      </Link>
                      <div
                        className={classname("dropdown-menu", { show: styles })}
                      >
                        <Link
                          to="/table-styles"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("Tables")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                        <Link
                          to="/list-styles"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("Lists")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                        <Link
                          to="/text-styles"
                          className="dropdown-item d-flex justify-content-between align-items-center"
                        >
                          {props.t("Texts")}
                          <i className="fas fa-chevron-right"></i>
                        </Link>
                      </div>
                    </li>
                  </>
                ) : null}
              </ul>
            </Collapse>
          </nav>
        </div>
      </div>
    </React.Fragment>
  );
};

Navbar.propTypes = {
  leftMenu: PropTypes.any,
  menuOpen: PropTypes.any,
  t: PropTypes.any,
};

const mapStateToProps = ({
  RolesReducer: { userRoles },
  Layout: { leftMenu },
}) => ({
  userRoles,
  leftMenu,
});

export default connect(mapStateToProps, {})(withTranslation()(Navbar));
